// AddLocations.js
import React from "react";
import CsvUploadForm from "./CsvUploadForm";

const AddLocations = () => {
  return (
    <div className="add-locations">
      <h2>Add Location</h2>
      <CsvUploadForm />
    </div>
  );
};

export default AddLocations;
